import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brand',
  templateUrl: '../../views/header/brand.component.html',
  styleUrls: ['../../../assets/css/header/brand.component.css']
})
export class BrandComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
